export default __webpack_public_path__ + "static/media/avatar_boy.4b6e084c.png";